<template>
  <div id="app">
    <el-container style="height: 100vh; overflow: hidden;">
      <el-main>
        <router-view></router-view>
      </el-main>
      <el-footer height="60px">
        <el-tabs v-model="activeTab" stretch @tab-click="handleTabClick">
          <el-tab-pane label="首页" name="home">
            <router-link to="/app_mini/home" tag="span" class="tab-link"></router-link>
          </el-tab-pane>
          <el-tab-pane label="咨询" name="consult">
            <router-link to="/app_mini/consult" tag="span" class="tab-link"></router-link>
          </el-tab-pane>
          <el-tab-pane label="我的" name="profile">
            <router-link to="/app_mini/profile" tag="span" class="tab-link"></router-link>
          </el-tab-pane>
        </el-tabs>
      </el-footer>
    </el-container>

    <Login ref="login" @loginSuccess="loginSuccess"></Login>
  </div>
</template>

<script>

import Login from './LoginModal';

export default {
  name: 'App',
  data() {
    return {
      login: false,
      activeTab: 'home'
    }
  },
  created: function () {
  },
  components: {
    Login,
  },
  methods: {
    handleTabClick(tab) {
      console.log(tab.name)
      this.activeTab = tab.name;
      this.$router.push('/app_mini/'+tab.name);
    },
    loginSuccess: function () {
      this.login = true;
      this.getUserInfo();
    },
    checkLogin: function () {
      let token = localStorage.getItem("token");
      if (!token) {
        this.$refs.login.init()
        return false;
      } else {
        return true;
      }
    }
  }
}
</script>

<style>
.el-footer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: #f5f5f5;
}

.tab-link {
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
}
</style>
